import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../helpers'

const Clock = () => {
  const [dateTime, setDateTime] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => setDateTime(new Date()), 1000)
    return () => clearInterval(interval)
  }, [])

  const formattedDate = dateTime.toLocaleDateString('en-US', { timeZone: 'America/Chicago', month: 'short', day: 'numeric', year: 'numeric' })
  const formattedTime = dateTime.toLocaleTimeString('en-US', { timeZone: 'America/Chicago', hour: '2-digit', minute: '2-digit' }) + ' CT'

  return (
    <div
      className='d-flex align-items-center gap-1 badge badge-light m-auto p-auto rounded-3 justify-content-center'
      style={{height: '35px', width: 'auto', paddingLeft: '12px', paddingRight: '12px'}}
    >
      <div className='d-flex gap-1 align-items-start flex-column'>
        <p className='m-auto fs-6 fw-bold text-gray-800'> {formattedDate}</p>
        <p className='m-auto fs-7 fw-semibold text-gray-600'> {formattedTime}</p>
      </div>
      <i className='ki-duotone ki-calendar-2 fs-2qx text-dark'>
        <span className='path1'></span>
        <span className='path2'></span>
        <span className='path3'></span>
        <span className='path4'></span>
        <span className='path5'></span>
      </i>
    </div>
  )
}

export default Clock
